import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeValidationSchemas } from './normalize';

export const fetchValidationSchemas = createProvider(api.fetchValidationSchemas)
  .andThen((res) => normalizeValidationSchemas(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch validation scheme aborted');
    } else {
      console.error('Fetch validation scheme was failed:', error);
    }
    throw error;
  });

export const validationSchemasQueryOptions = () => ({
  queryFn: () => fetchValidationSchemas(),
  queryKey: ['validation-schemas'],
  staleTime: 1000 * 60 * 60 * 1, // 1 hour
});
